// extracted by mini-css-extract-plugin
export default {"formLabel":"FormLabel-module__formLabel"};